import {UserConversationConditionTypes} from "./userConversationConstant";

export function userConversationListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      userConditions: resource.conditions.map((item) => ({conditions : getType(item)})),
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateUserConversation(json) {
  return {
    data: {...json.result, id: json.result.objectId},
  };
}

export function userConversationMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, userConditions: json.result.conditions.map((item) => ({conditions : getType(item)})),
    },
  };
}


export function getType(type) {
  return UserConversationConditionTypes[type].name;
}